// ============================================================
// What the material and surface editors share
// ============================================================
// The surface editor mirrors the material editor deliberately: the same
// collapsed-until-opened panel, the same name and colour, the same chip
// rows. A GM who has edited one already knows how to work the other.

import common from '../../styles/common.module.css';
import styles from '../../styles/Battlefield.module.css';
import { RadioChip } from './controls';

/** The "✎ Edit …" button that opens and closes the panel. */
export function EditorToggle({ open, setOpen, testId, children }) {
  return (
    <button
      type="button"
      className={common.btnSmall}
      aria-expanded={open}
      data-testid={testId}
      onClick={() => setOpen((o) => !o)}
    >
      {children}
    </button>
  );
}

/** The name and the colour - `what` names them for the screen reader ("Material", "Surface"). */
export function NameColourFields({ what, name, colour, onName, onColour }) {
  return (
    <>
      <label className={styles.buildField}>
        Name
        <input
          className={common.input}
          aria-label={`${what} name`}
          value={name}
          onChange={(e) => onName(e.target.value)}
        />
      </label>
      <label className={styles.buildField}>
        Colour
        <input
          className={common.input}
          type="color"
          aria-label={`${what} colour`}
          value={colour}
          onChange={(e) => onColour(e.target.value)}
        />
      </label>
    </>
  );
}

/** One property as a row of chips: `options` are `{ value, label, hint }`. */
export function OptionRow({ label, options, value, testPrefix, onPick }) {
  return (
    <div className={styles.brushRow} role="radiogroup" aria-label={label}>
      {options.map((o) => (
        <RadioChip
          key={o.value}
          checked={value === o.value}
          testId={`${testPrefix}${o.value}`}
          onClick={() => onPick(o.value)}
          title={o.hint}
        >
          {o.label}
        </RadioChip>
      ))}
    </div>
  );
}
